import React, { FC } from 'react';
import { useDisciplineGroupsQuery } from '../api';
import { Select } from '../components/Inputs';
import { ControllerProps } from 'react-hook-form/dist/types/props';

interface GroupDisciplines extends Pick<ControllerProps<'input'>, 'control' | 'name' | 'rules'> {
  label: string;
  error: boolean | undefined;
  filter?: any;
}

const GroupDisciplines: FC<GroupDisciplines> = ({ filter = {}, label, error, control, name, rules }) => {
  const { data } = useDisciplineGroupsQuery({ variables: { filter } });
  return (
    <Select
      label={label}
      data={(data && data.dirSportDisciplineGroups) || []}
      control={control}
      error={error}
      name={name}
      rules={rules}
    />
  );
};

export default GroupDisciplines;
